module.exports = __webpack_public_path__ + "img/delete-active.c18f637d.svg";